//
//
//
//
//
//
//
//
//
//

import GuaranteeText from './GuaranteeText.vue';

export default {
  components: {
    GuaranteeText,
  },
  props: {
    calloutType: {
      type: String,
      required: true,
    },
    refundableDays: {
      type: Number,
      required: true,
    },
    isFreebie: {
      type: Boolean,
      required: true,
    },
  },
};
